export function getMimeTypeFromFilename(mimeTypeExtensions, filename) {
  return Object.keys(mimeTypeExtensions)
    .find(mimeType => mimeTypeExtensions[mimeType]
      .find(extension =>
        extension
        && filename
        && filename.toUpperCase().endsWith(extension.toUpperCase()))
    );
}
